import React from 'react';
import PropTypes from 'prop-types';

const stopPropagation = event => event.stopPropagation();
const blockedEvents = [
  'onClick',
  'onContextMenu',
  'onDoubleClick',
  'onDrag',
  'onDragEnd',
  'onDragEnter',
  'onDragExit',
  'onDragLeave',
  'onDragOver',
  'onDragStart',
  'onDrop',
  'onMouseDown',
  'onMouseEnter',
  'onMouseLeave',
  'onMouseMove',
  'onMouseOver',
  'onMouseOut',
  'onMouseUp',
  'onKeyDown',
  'onKeyPress',
  'onKeyUp',
  'onFocus',
  'onBlur',
  'onChange',
  'onInput',
  'onInvalid',
  'onSubmit'
];

/*
  This component wraps a component in an html element that captures events and traps them (stops propagation)
  preventing them from bubbling upwards.
  This is due the way Portals in React work where clicking on an element rendered inside a portal
  will propagate the event through the component hierarchy instead of the DOM hierarchy.
  This causes specific use cases to work incorrectly such as Dialogs or IconDropdownMenu rendered
  inside containers that listen for various events causing their handlers to execute when they shouldn't.
*/
const StopOverlayPropagation = ({ children, allowedEvents = [] }) => {
  const eventsToBlock = blockedEvents.filter(
    event => allowedEvents.indexOf(event) === -1
  );
  let eventHandlers = {};

  eventsToBlock.forEach(event => {
    eventHandlers[event] = stopPropagation;
  });

  return <span {...eventHandlers}>{children}</span>;
};

StopOverlayPropagation.propTypes = {
  allowedEvents: PropTypes.arrayOf(PropTypes.oneOf(blockedEvents))
};

export default StopOverlayPropagation;
